import * as React from "react";
import classnames from "classnames";
import { Text } from "@grandvisionhq/elements";
/* empty css                   */
const StoreTileText = ({ className, children, ...rest }) => /* @__PURE__ */ React.createElement(Text, { ...rest, className: classnames("store-tile__typography-text", className) }, children);
export {
  StoreTileText as default
};
//# sourceMappingURL=StoreTileText.js.map
